var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "headline text-start align-start d-flex align-center",
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "cols": "auto"
    }
  }, [_vm.showsPrevButton ? [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "fab": "",
      "tile": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('prev');
      }
    }
  }, [_c('v-icon', [_vm._v(" mdi-chevron-left ")])], 1)] : _vm._e(), _c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")])], 2), _vm.$slots['subtitle'] ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._t("subtitle")], 2) : _vm._e(), _c('v-spacer'), _vm.showsFilterButton || _vm.$scopedSlots['buttons'] ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._t("buttons"), _vm.showsFilterButton ? _c('v-btn', {
    staticClass: "ml-3 my-n2",
    attrs: {
      "color": "secondary",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', !_vm.value);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-filter-variant")]), _vm._v("검색필터")], 1) : _vm._e()], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }